import { useEffect } from "react";
import styles from "./index.module.scss";
import logger from "../../services/logger";

export default function Ad({ adsIndex, isMobile }: { adsIndex: number; isMobile: boolean }): JSX.Element {
  const firstSlotNameDesktop = "007-CONTENTBOARD";
  const firstSlotNameMobile = "104-RECTANGLE-MOBI";
  const baseSlotNameDesktop = "011-MIDBOARD";
  const baseSlotNameMobile = "011-MIDBOARD-MOBI";

  --adsIndex;

  let slotName: string;
  if (isMobile) {
    slotName = adsIndex !== 0 ? baseSlotNameMobile : firstSlotNameMobile;
  } else {
    slotName = adsIndex !== 0 ? baseSlotNameDesktop : firstSlotNameDesktop;
  }
  const slotDivId = `DFP-${slotName}_${adsIndex}`;

  useEffect(() => {
    if (window?.putBanDFPInViewObject) {
      const adParams = {
        slot: slotName,
        divId: slotDivId,
      };

      if (slotName !== firstSlotNameDesktop && slotName !== firstSlotNameMobile) {
        window.putBanDFPInViewObject(adParams);
      } else if (window?.putBanDFP) {
        window.putBanDFP(slotName, slotDivId);
      }
    }

    return () => {
      window.googletag
        .pubads()
        .getSlots()
        .forEach(function (slot) {
          if (slot.getSlotElementId() === slotDivId) {
            logger.info("Reset slot:", slotDivId);
            window.googletag.destroySlots([slot]);
          }
        });
    };
  }, []);

  return (
    <div className={[styles.wrapper, styles.background, isMobile ? styles.mobile : ""].join(" ")}>
      <div
        id={slotDivId}
        className={["activeBan", "adviewDFPBanner", slotName === firstSlotNameMobile ? styles.rectangleMobi : ""].join(
          " "
        )}
        data-e={`notes-ad-wrapper-${slotName}`}
      ></div>
    </div>
  );
}
